'use client';

import { useUser } from '@clerk/nextjs';

/**
 * Client-side mirror of the server's `needsPayment(ctx)` (`@/infra/auth/authorization`), read from
 * Clerk `publicMetadata` instead of a server user context.
 *
 * Needed because the sprint can now be reached BEFORE the paywall (see `app/(platform)/labs/layout.tsx`),
 * so its screens have to know whether the learner has actually subscribed. The engine renders on the
 * client, where the server context is unavailable.
 *
 * Keep the predicate identical to the server's: no subscription, `PENDING`, or `CANCELED` all count as
 * still needing payment. If the two ever drift, a pre-paywall learner gets routed at the end of the
 * sprint to a page the layout will bounce them off, which reads as a dead end.
 */
export function useNeedsPayment(): boolean {
  const { user, isLoaded } = useUser();

  if (!isLoaded) {
    return false;
  }

  const status = user?.publicMetadata?.subscription_status;
  return status !== 'ACTIVE';
}
